import { observable, runInAction } from 'mobx';
import { get } from '../utils';

class GetUnRegionIds {
    private route: string;
    private params: any;
    @observable
    public getUnRegion: any;

    constructor(params: any) {
        this.route = params.url;
        this.params = params;
    }

    async fetch(callback?, errs?) {
        var obj = Object.assign(this.params);
        get(this.route, obj).then((d) => {
            let data;
            if (d.data) {
                data = d.data;
                runInAction(() => {
                    this.getUnRegion = data;
                    callback && (this.getUnRegion = callback(data));
                });
            } else {
                callback && callback([]);
            }
        }).catch((err) => {
            errs && errs(err);
        });
    }
}

export default GetUnRegionIds;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/getUnRegionIds.ts